import { Controller } from "@hotwired/stimulus"

// Prevent dropdown from closing when interacting with inputs inside it (Bootstrap 4)
export default class extends Controller {
  connect() {
    this._onClick = (e) => e.stopPropagation()
    this.element.addEventListener('click', this._onClick)
  }

  disconnect() {
    this.element.removeEventListener('click', this._onClick)
  }
}
